import {useMemo} from 'react';

import {ActiveFilterSectionContent, TreeViewSectionConfig} from 'filters/features/FilterDialog/types';

import {openFilterDialog} from 'filters/features/FilterDialog/emitter';
import {
  ActiveFiltersProvider,
  useActiveFiltersContext,
} from 'filters/features/FilterDialog/sections/ActiveFiltersSection/contexts/ActiveFiltersContext';
import {useEditedFilterContext} from 'filters/features/FilterDialog/contexts/internal/EditedFilterProvider/EditedFilterProvider';

import {ActiveFiltersContent} from 'filters/features/FilterDialog/sections/ActiveFiltersSection/components/ActiveFiltersContent';
import {SectionCollapse} from 'filters/features/FilterDialog/sections/ActiveFiltersSection/components/SectionCollapse';

// FIXME: Replace filter with values
export const TreeViewActiveFilters = ({
  id,
  title,
  useTreeData,
  getDataOptions,
  getValue,
  onChange,
  useTreeSelection,
  selectionOptions = {},
  collapsibleActiveFilterSection,
}: TreeViewSectionConfig<any, any, any, any, any>) => {
  const {overrideContent} = useActiveFiltersContext();

  const {filter, setFilter} = useEditedFilterContext();
  const value = getValue(filter);

  const treeData = useTreeData(getDataOptions?.(value));

  const {selected, overrideActiveFilterContent, setSelected, isDisabled} = useTreeSelection(
    treeData,
    {
      value,
      setValue: value => setFilter(prev => onChange(prev, value)),
    },
    selectionOptions
  );

  const content = useMemo<ActiveFilterSectionContent>(() => {
    if (overrideActiveFilterContent) {
      return overrideActiveFilterContent({sectionId: id});
    }

    return [
      {
        id: id,
        disabled: isDisabled,
        chips: selected.map(key => ({
          id: key,
          disabled: isDisabled,
          label: treeData.treeMap.get(key)?.title || key,
          onClick: () => openFilterDialog(id),
          onDelete: () => setSelected(selected.filter(k => k !== key)),
        })),
      },
    ];
  }, [id, isDisabled, overrideActiveFilterContent, selected, setSelected, treeData.treeMap]);

  return (
    <ActiveFiltersProvider loading={treeData.loading} overrideContent={overrideContent}>
      <SectionCollapse collapsible={collapsibleActiveFilterSection} title={title}>
        <ActiveFiltersContent content={content} />
      </SectionCollapse>
    </ActiveFiltersProvider>
  );
};
